import React, { useState, useContext, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

import { domHelper, localstorageHelper } from 'helpers';
import { cognitoService } from 'services';
import { UserContext } from 'contexts';
import { parseEmail } from 'utils/regex';

import {
  Wrapper,
  CloseModalButton,
  LoginForm,
  NormalFieldSet,
  SocialFieldSet,
  FormTitle,
  Field,
  Button,
  SocialField,
  RegisteredTitle,
  ButtonOutline,
  Subtitle,
  Section,
} from './styles';

import CloseIcon from '/static/icons/controls/close.svg';
import PasswordIcon from '/static/icons/auth/password.svg';
import UserIcon from '/static/icons/auth/user.svg';
import GoogleIcon from '/static/icons/auth/google.svg';
import AppleIcon from '/static/icons/auth/apple.svg';
import FacebookIcon from '/static/icons/auth/facebook.svg';
import LoadingGif from '/static/gifs/loading.gif';
import {Auth} from "aws-amplify";
import { socialProviders } from '../../constants';

export const Login = ({ data, setData, onClose, onRegister, onConfirm, onLegacyAccount }) => {
  const pageTitles = ['Sign In', 'Forgot password', 'Reset password']; // Manage dynamic page titles by page-index
  const { setUser, createNotification } = useContext(UserContext); // Context API to update user state
  const { email, password, authCode, newPassword, forgotEmail } = data.user;
  const { error, pageIndex, bLoading } = data.meta;
  const [bShowPassword, setBShowPassword] = useState(false); // boolean value to show/hide password

  const handleUserChange = e =>
    setUserData({ [e.target.name]: e.target.value });
  const setUserData = newData => {
    setData({ ...data, user: { ...data.user, ...newData } });
  };
  const setMetaData = newData => {
    setData({ ...data, meta: { ...data.meta, ...newData } });
  };
  const updateData = newData => {
    setData({
      meta: { ...data.meta, ...newData.meta },
      user: { ...data.user, ...newData.user },
    });
  };
  const reset = () => {
    updateData({
      user: { password: '', authCode: '', newPassword: '' },
      meta: { bLoading: false, error: '' },
    });
  };
  useEffect(() => {
    reset();
  }, [pageIndex]);

  const handleFormSubmit = async ev => {
    ev.preventDefault();
    setMetaData({ error: '' });
    try {
      if (pageIndex === 0 && bLoading == false) {
        // save the user-info retrived from Cognito signin method
        setMetaData({ bLoading: true });
        const user = await cognitoService.signIn(email, password);
        localstorageHelper.saveUser(user);
        createNotification('success', "You're logged in");
        setUser(user);
        setUserData({ email: '', password: '', forgotEmail: '' });
        onClose();
      } else if (pageIndex === 1) {
        if (!parseEmail(forgotEmail))
          throw { message: 'Invalid email address format.' };
        setMetaData({ bLoading: true });
        await cognitoService.sendCode(forgotEmail);
        setMetaData({ bLoading: false, pageIndex: pageIndex + 1 });
      } else if (pageIndex === 2) {
        setMetaData({ bLoading: true });
        await cognitoService.resetPassword(forgotEmail, authCode, newPassword);
        updateData({
          user: { email: forgotEmail, password: '' },
          meta: { bLoading: false, pageIndex: 0 },
        });
      }
    } catch (err) {
      setMetaData({ bLoading: false, error: err.message });
      ////console.log('error loggingin', err);
      if (err.message.startsWith('User is not confirmed')) {
        onConfirm(email);
      }
    }
  };
  const changeStep = (ev, i) => {
    setMetaData({ pageIndex: i });
  };
  const handleSocialLogin = async provider => {
    try {
      const {
        data,
        tab,
        isBrowserClosed,
      } = await cognitoService.federatedSignIn(provider);
      if (data) {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const user =  await cognitoService.checkUser("",cognitoUser.attributes.email);
        setUser(user);
      }
      tab.close();
      if (!isBrowserClosed) {
        onClose();
      }
    } catch (err) {
      ////console.log('error loggingin', err);
      setMetaData({ error: err.message });
    }
  };
  const changePasswordType = id => {
    domHelper.changeProperty(id, 'type', !bShowPassword ? 'text' : 'password');
    setBShowPassword(!bShowPassword);
  };
  return (
    <Wrapper>
      {bLoading && (
        <Section className="loading-wrapper">
          <img
            className="loading-gif large"
            src={LoadingGif}
            alt="image loading"
          />
        </Section>
      )}
      <CloseModalButton onClick={onClose}>
        <CloseIcon />
      </CloseModalButton>
      <LoginForm onSubmit={handleFormSubmit}>
        <FormTitle>{pageTitles[pageIndex]}</FormTitle>
        {error && <p className="error">{error}</p>}
        {pageIndex === 0 && (
          <>
            <NormalFieldSet className={bLoading ? 'no-action' : ''}>
              <Field>
                <span>
                  <UserIcon />
                </span>
                <input
                  type="email"
                  required
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={handleUserChange}
                />
              </Field>
              <Field>
                <span>
                  <PasswordIcon />
                </span>
                <input
                  type="password"
                  placeholder="Password"
                  id="login-password"
                  required
                  name="password"
                  value={password}
                  onChange={handleUserChange}
                />
                <FontAwesomeIcon
                  icon={bShowPassword ? faEyeSlash : faEye}
                  onClick={ev => changePasswordType('login-password')}
                />
              </Field>
              <Button type="submit" value="Login" />
              <Subtitle
                className="forgot-password"
                onClick={onRegister}
                >
                New customer?
              </Subtitle>
              <Subtitle
                className="forgot-password"
                onClick={ev => changeStep(ev, 1)}
              >
                Forgot your password?
              </Subtitle>
              {/*<Subtitle
                className="forgot-password"
                onClick={onLegacyAccount}
                >
                Have an account with <b>simplysay.sg</b>?
            </Subtitle>*/}
            </NormalFieldSet>
            <SocialFieldSet>
              <SocialField className="google">
                <span>
                  <GoogleIcon />
                </span>
                <label
                  name="Google"
                  onClick={() => handleSocialLogin(socialProviders.GOOGLE)}
                >
                  Sign in with Google
                </label>
              </SocialField>
              <SocialField className="facebook" name="Facebook">
                <span>
                  <FacebookIcon />
                </span>
                <label
                  name="Facebook"
                  onClick={() => handleSocialLogin(socialProviders.FACEBOOK)}
                >
                  Sign in with Facebook
                </label>
              </SocialField>
              <SocialField className="apple" name="Apple">
                <span>
                  <AppleIcon />
                </span>
                <label
                    name="Apple"
                    onClick={() => handleSocialLogin(socialProviders.APPLE)}
                >
                  Sign in with Apple
                </label>
              </SocialField>
            </SocialFieldSet>
          </>
        )}
        {pageIndex === 1 && (
          <>
            <NormalFieldSet>
              <Field>
                <span>
                  <UserIcon />
                </span>
                <input
                  type="text"
                  required
                  name="forgotEmail"
                  value={forgotEmail}
                  onChange={handleUserChange}
                  placeholder="Email to send a code"
                />
              </Field>
              <Button type="submit" value="Send" />
            </NormalFieldSet>
            <Section>
              <Subtitle onClick={ev => changeStep(ev, 0)}>Remembered your password?</Subtitle>
            </Section>
          </>
        )}
        {pageIndex === 2 && (
          <>
            <NormalFieldSet>
              <Field>
                <span>
                  <FontAwesomeIcon icon={faUserCheck} />
                </span>
                <input
                  type="number"
                  required
                  name="authCode"
                  value={authCode}
                  onChange={handleUserChange}
                  placeholder="Verification code"
                />
              </Field>
              <Field>
                <span>
                  <PasswordIcon />
                </span>
                <input
                  id="new-password"
                  type="password"
                  required
                  name="newPassword"
                  value={newPassword}
                  onChange={handleUserChange}
                  placeholder="New password"
                />
                <FontAwesomeIcon
                  icon={bShowPassword ? faEyeSlash : faEye}
                  onClick={ev => changePasswordType('new-password')}
                />
              </Field>
              <Button type="submit" value="Confirm" />
              <Section className="helper-section">
                <span>
                  <Subtitle>Didn't received a code?</Subtitle>
                  <Subtitle
                    className="action"
                    onClick={ev => changeStep(ev, 1)}
                  >
                    Resend
                  </Subtitle>
                </span>
                <span>
                  <Subtitle>Got a password?</Subtitle>
                  <Subtitle
                    className="action"
                    onClick={ev => changeStep(ev, 0)}
                  >
                    Login
                  </Subtitle>
                </span>
              </Section>
            </NormalFieldSet>
          </>
        )}
      </LoginForm>
    </Wrapper>
  );
};
